import {formatDate} from '../../../helpers/utils';

export const COMMON_REQ = 'cris/workInspection/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/workInspection/COMMON_REQ_FAIL';

export const LOAD_WORK_INSPECTIONS_SUCCESS = 'cris/workInspection/LOAD_WORK_INSPECTIONS_SUCCESS';

const initialState = {
	isLoading: false,
	error: null,
	workOrders: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_WORK_INSPECTIONS_SUCCESS:
			const workOrders = action.payload.data.work_orders.map((item) => ({
				id: item.id,
				code: item.code,
				prr_ncn: item.prr_ncn || '',
				job_description: item.job_description,
				start_date: item.start_date,
				formattedStartDate: formatDate(item.start_date),
				old_code: item.old_code || '',
				customerName: item.customer ? item.customer.name : '',
				jobLocationName: item.job_location ? item.job_location.name : ''
			}));

			return {
				...state,
				isLoading: false,
				workOrders: workOrders
			};

		default:
			return state;
	}
}